import React, { type ReactElement } from 'react';

import { ClusterSectionProps } from './interfaces';

const ClusterSection = ({ children, className, headline }: ClusterSectionProps): ReactElement => (
  <section className={className}>
    <header className="md:mx-auto md:max-w-[848px] lg:max-w-none">
      <h2 className="m-0 font-suisse-works text-headline-xs sm:text-headline-sm">{headline}</h2>
    </header>
    {children}
  </section>
);

export default ClusterSection;
